import ContentBodyLoader from "../Content/ContentBody/ContentBodyLoader";
import QualityIssuesIcon from "assets/icons/QualityIssuesIcon";
import VLAccordian from "views/components/Accordian";
import { FilterItemCountsWithSelect, RightPaneMetrics } from "types";
import { useState } from "react";
import Content from "../Content";

import styles from "../style.module.scss";

const QUALITY_SECTION_ID = "quality-1";

interface QualitySectionProps {
  issueTypes: Array<FilterItemCountsWithSelect>;
  sectionHeight: number | false;
  isLoading: boolean;
  qualityRef: any;
}

interface QualitySectionContentProps {
  issueTypes: Array<FilterItemCountsWithSelect>;
  selectedMetric: RightPaneMetrics;
  sectionHeight: number | false;
  isLoading: boolean;
}

function NoQualityData() {
  return (
    <div className={styles.noDataWrapper}>
      <div className={styles.noData}>
        Currently no Issue Types available in this cluster
      </div>
    </div>
  );
}

const QualitySectionContent = ({
  isLoading,
  issueTypes,
  sectionHeight,
  selectedMetric,
}: QualitySectionContentProps) => {
  const initialSelectedID = sectionHeight ? QUALITY_SECTION_ID : null;
  const [selectedID, setSelectedID] = useState<string | null>(
    initialSelectedID,
  );

  return (
    <div
      className={styles.section}
      style={{ height: !!sectionHeight ? sectionHeight : "max-content" }}
    >
      <Content
        searchDisabled
        data={issueTypes}
        type={"issue-types"}
        title={"Issue Types"}
        sectionType={"quality"}
        isLoading={isLoading}
        id={QUALITY_SECTION_ID}
        selectedID={selectedID}
        selectedMetric={selectedMetric}
        setSelectedID={setSelectedID}
      />
    </div>
  );
};

const QualitySection = ({
  issueTypes,
  qualityRef,
  sectionHeight,
  isLoading,
}: QualitySectionProps) => {
  const [selectedMetric, setSelectedMetric] =
    useState<RightPaneMetrics>("COUNT");

  const onToggleMetrics = () => {
    setSelectedMetric(selectedMetric === "PERCENTAGE" ? "COUNT" : "PERCENTAGE");
  };

  const handleDisplay = () => {
    if (isLoading && !issueTypes.length) {
      return (
        <div className={styles.loadingBox}>
          <ContentBodyLoader center />
        </div>
      );
    } else if (issueTypes.length > 0) {
      return (
        <QualitySectionContent
          isLoading={isLoading}
          issueTypes={issueTypes}
          sectionHeight={sectionHeight}
          selectedMetric={selectedMetric}
        />
      );
    } else return <NoQualityData />;
  };
  return (
    <div className={styles.qualityWrapper} ref={qualityRef}>
      <VLAccordian
        key="Issues"
        title="Issues"
        id={QUALITY_SECTION_ID}
        inSearch={!!sectionHeight}
        icon={<QualityIssuesIcon />}
        selectedMetric={selectedMetric}
        allowResize={issueTypes.length > 5}
        className={styles.metadataSectionAccordian}
        isLoading={isLoading && !!issueTypes.length}
        onToggleMetrics={onToggleMetrics}
      >
        {handleDisplay()}
      </VLAccordian>
    </div>
  );
};

export default QualitySection;
